module.exports = __webpack_public_path__ + "img/create.ab9bce07.svg";